// src/lib/dpcHover.ts (2026-07-22 新設)
// DPC 処置1/2 セルのホバー文字列を組み立てる。DPC分析主表 (DiseaseRankingTable) と
// 粗利分析 DPC別 (ProfitTable) で同じ文面を使うための共通ヘルパー。
//
// [分岐該当/併施の分離 2026-07-22 ユーザ指示] 以前は「実施された処置2系の処置がすべて並びます」
// と全件を1つのリストで出していたため、その分岐を決めた処置と併施の区別がつかなかった。
// server 側で公式対応表 (dim_dpc11_cand / dim_dpc12_cand) に各入院自身の 11/12 桁目で当てて
// 振り分けた 2 本のリストを受け取り、ここで書き分ける。

export function procHover(opts: {
  n: 1 | 2;            // 処置1 / 処置2
  branchName: string;  // 分岐名 (空 = その行の DPC が 11/12 桁まで確定していない)
  jisseki: string;     // 分岐に該当する実績K (" / " 区切り)
  heishi: string;      // 併施 (分岐外) の実績K
  candK: string;       // 分岐に対応する候補Kコード (公式対応表)
  candName: string;    // 候補K の名称
}): string {
  const digit = opts.n === 1 ? 11 : 12;
  const nl = (s: string) => s.split(" / ").join("\n");
  // 分岐名が空 = コーディング未確定 (dpc14 が 6 桁のみ 等)。この行は「該当/併施」を判定できない
  // ので、併施側のリストを「実績処置K (判定不能)」として出す (併施と誤読させない)。
  const undecided = !opts.branchName;
  return [
    `処置${opts.n}(分岐): ${opts.branchName || "(14桁未確定)"}`,
    opts.jisseki
      ? `── この分岐に該当する実績処置K (${digit}桁目を決めた処置・件数降順) ──\n${nl(opts.jisseki)}`
      : "",
    opts.heishi
      ? (undecided
          ? `── 実績処置K (件数降順) ──\n${nl(opts.heishi)}\n`
            + `※この行は DPC が ${digit} 桁まで確定していないため、分岐に該当する処置を判定できません`
          : `── 併施 (分岐外・${digit}桁目には効かない) ──\n${nl(opts.heishi)}`)
      : "",
    opts.candK
      ? `── 分岐に対応する候補K (公式対応表・当院実績の有無を問わず) ──\n${opts.candK}\n${nl(opts.candName || "")}`
      : "",
  ].filter(Boolean).join("\n");
}
